import { React, useEffect, useState } from "react";
import ToolsTab from "../../../components/toolsTab";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import VideoBanner from "../../../components/videoBanner";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const INaturalistScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const main_page_video = "mMN2daZ2pUg";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={main_page_video}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit  ">
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[60rem] col-span-2 lg:h-[60rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Todos los grupos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      iNaturalist
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[5rem] mg:pb-[5rem] sm:pb-[5rem] pb-[5rem]">
                      En la aplicación <b>iNaturalist</b> el monitoreo empieza
                      con la acción de observar y fotografiar un animal
                      silvestre. Posteriormente, la aplicación comparte la
                      observación con la comunidad iNaturalist, que devuelve
                      comentarios e identificaciones. Las observaciones con
                      grado de investigación son compartidas con científicos que
                      trabajan para{" "}
                      <b>entender y proteger mejor la naturaleza</b>.
                    </p>
                  }
                ></ToolsInfoSection>

=              </div>
              <div className="relative col-span-3 2xl:mt-[50rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                  <ToolsTab
                   firstTitle="Utilizable en casi cualquier sitio"
                   secondTitle="Resultados y beneficios"
                    firstTab={
                      <p className="text-xl">
                        La aplicación puede ser utilizada en cualquier sitio, ya sea campo o ciudad. El único requisito es contar con un teléfono celular. Esta aplicación permite compartir la información con grandes bases de datos de biodiversidad como “Global Biodiversity Information Facility”, la cual ayuda a los científicos a encontrar y utilizar sus datos.
                      </p>
                    }
                    secondTab={
                      <div>
                        <p className="text-xl mb-5">
                          Esta aplicación nació con la idea de que todas las
                          personas que sienten curiosidad por la naturaleza
                          puedan compartir su interés con la comunidad
                          científica.
                        </p>
                        <p className="text-xl mb-5">
                        Para una empresa esta aplicación puede ser el primer paso para empezar a crear una línea base de biodiversidad en sus terrenos, ya que permite delimitar un área geográfica para reportar las observaciones.
                        </p>
                      </div>
                    }
                  ></ToolsTab>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute ">
            <VideoBanner idVideo={main_page_video}></VideoBanner>
          </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[30rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <ToolsInfoSection
                firstIcon={ico_handy_orange}
                secondIcon={ico_huellas_green}
                tag="Todos los grupos"
                title={
                  <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                    iNaturalist
                  </h1>
                }
                text={
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[15rem] mg:pb-[10rem] sm:pb-[10rem] pb-[10rem]">
                    En la aplicación <b>iNaturalist</b> el monitoreo empieza con
                    la acción de observar y fotografiar un animal silvestre.
                    Posteriormente, la aplicación comparte la observación con la
                    comunidad iNaturalist, que devuelve comentarios e
                    identificaciones. Las observaciones con grado de
                    investigación son compartidas con científicos que trabajan
                    para <b>entender y proteger mejor la naturaleza</b>.
                  </p>
                }
              ></ToolsInfoSection>

            </div>

            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
              <ToolsTab
              firstTitle="Utilizable en casi cualquier sitio"
              secondTitle="Resultados y beneficios"
                firstTab={
                  <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    La aplicación puede ser utilizada en cualquier sitio, ya sea campo o ciudad. El único requisito es contar con un teléfono celular. Esta aplicación permite compartir la información con grandes bases de datos de biodiversidad como “Global Biodiversity Information Facility”, la cual ayuda a los científicos a encontrar y utilizar sus datos.
                  </p>
                }
                secondTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Esta aplicación nació con la idea de que todas las
                      personas que sienten curiosidad por la naturaleza puedan
                      compartir su interés con la comunidad científica.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    Para una empresa esta aplicación puede ser el primer paso para empezar a crear una línea base de biodiversidad en sus terrenos, ya que permite delimitar un área geográfica para reportar las observaciones.
                    </p>
                  </div>
                }
              ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default INaturalistScreen;
